import { Link } from "react-router-dom";
import { Cpu } from "lucide-react";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="mt-16 border-t border-[#1E2638] bg-[#080B10]">
      <div className="h-1 w-full bg-gradient-to-r from-[#0055A4] via-white to-[#EF4135]" />
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 py-6 text-center md:flex-row md:justify-between md:text-left">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <Cpu className="h-4 w-4" />
          </span>
          <span className="font-head text-sm font-bold">
            llm<span className="text-primary">etric</span>
          </span>
        </div>

        <p className="text-sm text-muted-foreground">
          © {year} <span className="font-semibold text-foreground">Habily Bouchaib</span> · France ·{" "}
          <Link to="/a-propos" data-testid="footer-about-link" className="text-primary hover:underline">
            À propos
          </Link>
        </p>
      </div>
    </footer>
  );
}
